export type AppName = 'Services' | 'Groups'
